import { render, staticRenderFns } from "./personedit.vue?vue&type=template&id=081917e8&scoped=true&"
import script from "./personedit.vue?vue&type=script&lang=js&"
export * from "./personedit.vue?vue&type=script&lang=js&"
import style0 from "./personedit.vue?vue&type=style&index=0&id=081917e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081917e8",
  null
  
)

export default component.exports